import type { SxProps, Theme } from '@mui/material/styles'

export const COMMAND_BAR_PANEL_BG = '#0B1220'

export const commandBarBackdropSx: SxProps<Theme> = {
  position: 'fixed',
  inset: 0,
  zIndex: (theme) => theme.zIndex.modal + 2,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  pt: { xs: 6, sm: 10 },
  px: 2,
  // Discret : la page reste lisible derrière la palette (TEC-1956).
  backgroundColor: 'rgba(17, 25, 39, 0.25)',
  backdropFilter: 'blur(3px)',
}

export const commandBarPanelSx: SxProps<Theme> = {
  width: '100%',
  maxWidth: 640,
  maxHeight: 'min(70vh, 560px)',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 1,
  border: '1px solid rgba(255, 255, 255, 0.08)',
  backgroundColor: COMMAND_BAR_PANEL_BG,
  boxShadow: '0 24px 48px rgba(0, 0, 0, 0.45)',
  overflow: 'hidden',
}

export const commandBarSectionTitleSx: SxProps<Theme> = {
  px: 2,
  pt: 1.5,
  pb: 0.5,
  fontSize: '0.7rem',
  fontWeight: 700,
  letterSpacing: '0.04em',
  textTransform: 'uppercase',
  color: 'primary.main',
}

export const getCommandBarItemSx = (
  selected: boolean,
  disabled = false
): SxProps<Theme> => ({
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  px: 1.5,
  py: 1,
  mx: 1,
  borderRadius: 1.5,
  cursor: disabled ? 'default' : 'pointer',
  border: '1px solid',
  borderColor: selected ? 'rgba(255, 255, 255, 0.16)' : 'transparent',
  backgroundColor: selected ? 'rgba(255, 255, 255, 0.08)' : 'transparent',
  opacity: disabled ? 0.4 : 1,
  pointerEvents: disabled ? 'none' : 'auto',
  '&:hover': disabled
    ? undefined
    : {
        backgroundColor: 'rgba(255, 255, 255, 0.06)',
      },
})

export const commandBarFooterSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 2,
  px: 2,
  py: 1.25,
  borderTop: '1px solid rgba(255, 255, 255, 0.08)',
  color: 'rgba(255, 255, 255, 0.45)',
  fontSize: '0.75rem',
}

export const commandBarKeycapSx: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 22,
  height: 20,
  px: 0.75,
  borderRadius: 0.75,
  border: '1px solid rgba(255, 255, 255, 0.16)',
  backgroundColor: 'rgba(255, 255, 255, 0.04)',
  color: 'rgba(255, 255, 255, 0.7)',
  fontSize: '0.65rem',
  fontWeight: 600,
  lineHeight: 1,
}
